import { useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const initials = (name) =>
  (name || "?").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

// Circular employee avatar: real photo (lazy, cover) with graceful initials fallback.
export const EmployeeAvatar = ({ id, nama, hasPhoto, size = 36, className = "" }) => {
  const [failed, setFailed] = useState(false);
  const show = id && hasPhoto && !failed;
  const px = { width: size, height: size };
  if (show) {
    return (
      <img
        data-testid={`emp-avatar-${id}`}
        src={`${BACKEND}/api/employees/${id}/photo`}
        alt={nama || "Employee"}
        loading="lazy"
        onError={() => setFailed(true)}
        style={{ ...px, objectPosition: "center" }}
        className={`shrink-0 rounded-full object-cover ring-1 ring-black/5 ${className}`}
      />
    );
  }
  return (
    <span
      data-testid={`emp-avatar-fallback-${id || "x"}`}
      style={{ ...px, fontSize: Math.round(size * 0.38) }}
      className={`grid shrink-0 place-items-center rounded-full bg-gradient-to-br from-[#D6E4F5] to-[#EDE9F5] font-semibold text-[#4A5568] ring-1 ring-black/5 ${className}`}
    >
      {initials(nama)}
    </span>
  );
};

export default EmployeeAvatar;
